<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Templates">
            <div class="filter-bar ui basic segment grid">
              <div class="ui form">
                  <div class="inline field">
                      <label>Search for:</label>
                      <input type="text" v-model="filterText" class="three wide column" @keyup.enter="doFilter" placeholder="code, description, en content">
                      <button class="ui primary button" @click="doFilter">Go</button>
                      <button class="ui button" @click="resetFilter">Reset</button>
                  </div>
              </div>
          </div>
          <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions">
            <template slot="actions" slot-scope="props">
              <div class="table-button-container">
                <button class="btn btn-info" @click="editTemplate(props.rowData)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
                <button class="btn btn-danger" @click="deleteTemplate(props.rowData._id)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
              </div>
            </template>
          </vuetable>
          <div class="vuetable-pagination ui basic segment grid">
              <vuetable-pagination-info ref="paginationInfo"
              ></vuetable-pagination-info>
              <vuetable-pagination ref="pagination"
              @vuetable-pagination:change-page="onChangePage"
              ></vuetable-pagination>
          </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <form action="#" method="POST" class="createAffiliate">
        <h3>Add a new template</h3>
        <br/>
        <div class="form-group">
          <label class="text-info">Template name:</label>
          <input class="form-control" type="text" placeholder="Ex: betNow" required="required" v-model="tname">
        </div>
        <div class="form-group">
          <label class="text-info">Description (optional):</label>
          <textarea class="form-control" placeholder="Template description" v-model="description"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">English content (required):</label>
          <textarea class="form-control" placeholder="English content here!" v-model="gb_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Germany content:</label>
          <textarea class="form-control" placeholder="Germany content here" v-model="de_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Denmark content:</label>
          <textarea class="form-control" placeholder="Denmark content here!" v-model="dk_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Chinese content:</label>
          <textarea class="form-control" placeholder="Chinese content here!" v-model="cn_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Romanian content:</label>
          <textarea class="form-control" placeholder="Romanian content here!" v-model="ro_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Portuguese content:</label>
          <textarea class="form-control" placeholder="Portuguese content here!" v-model="pt_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Spanish content:</label>
          <textarea class="form-control" placeholder="Spanish content here!" v-model="es_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Italiano content:</label>
          <textarea class="form-control" placeholder="Italiano content here!" v-model="it_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Hungarian content:</label>
          <textarea class="form-control" placeholder="Hungarian content here!" v-model="hu_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Polish content:</label>
          <textarea class="form-control" placeholder="Polish content here!" v-model="pl_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Czech content:</label>
          <textarea class="form-control" placeholder="Czech content here!" v-model="cz_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Slovak content:</label>
          <textarea class="form-control" placeholder="Slovak content here!" v-model="sk_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Holland content:</label>
          <textarea class="form-control" placeholder="Holland content here!" v-model="nl_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Bulgary content:</label>
          <textarea class="form-control" placeholder="Bulgary content here!" v-model="bg_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Swedish content:</label>
          <textarea class="form-control" placeholder="Swedish content here!" v-model="sv_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Norvegian content:</label>
          <textarea class="form-control" placeholder="Norvegian content here!" v-model="no_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Greek content:</label>
          <textarea class="form-control" placeholder="Greek content here!" v-model="gr_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Russian content:</label>
          <textarea class="form-control" placeholder="Russian content here!" v-model="ru_content"></textarea>
        </div>
        <div class="form-group">
          <label class="text-info">Estonian content:</label>
          <textarea class="form-control" placeholder="Estonian content here!" v-model="et_content"></textarea>
        </div>
        <div class="form-group">
          <br/>
          <button type="submit" class="btn btn-secondary form-control" @click.prevent="saveTemplate">Save</button>
        </div>
        <br/>
          <div class="alert alert-danger" role="alert" v-if="errors">{{errors}}</div>
      </form>
          </b-card>

        </b-col>

    </b-row>
    </div>
  <edit-template-modal></edit-template-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import { Bus } from '@/main'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import EditTemplateModal from '@/views/modals/EditTemplateModal'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    'edit-template-modal': EditTemplateModal
  },
  data () {
    return {
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      perPage: 10,
      moreParams: {},
      filterText: '',
      tname: '',
      description: '',
      gb_content: '',
      de_content: '',
      dk_content: '',
      no_content: '',
      cn_content: '',
      ro_content: '',
      es_content: '',
      it_content: '',
      hu_content: '',
      pl_content: '',
      cz_content: '',
      sk_content: '',
      pt_content: '',
      nl_content: '',
      bg_content: '',
      sv_content: '',
      gr_content: '',
      ru_content: '',
      et_content: '',
      errors: '',
      api_url: '',
      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'name',
          title: 'Template name',
          sortField: 'name',
          callback: 'formatTemplateName'

        },
        {
          name: 'description',
          title: 'Description',
          sortField: 'description'
        },
        {
          name: 'gb_content',
          title: 'Default(GB)',
          // titleClass: 'text-center',
          sortField: 'gb_content'
          // dataClass: 'center aligned'
        },
        {
          name: 'created_at',
          title: 'Created',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: 'langs',
          title: 'Langs',
          dataClass: 'text-center',
          titleClass: 'text-center',
          callback: 'formatLangs'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }

      ],

      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  methods: {
    formatTemplateName (value) {
      return `{{${value}}}`
    },
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    formatActions (value) {
      return `<i ref="delete_${value}" @click="console.log('test')" class="fas fa-trash-alt"></i>`
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    formatIsDefault (value) {
      return (!value)
        ? ''
        : '<i class="fas fa-check-square"></i>'
    },
    saveTemplate () {
      if (this.tname) {
        const formData = new FormData()
        formData.append('name', this.tname)
        formData.append('description', this.description)
        formData.append('gb_content', this.gb_content)
        formData.append('de_content', this.de_content)
        formData.append('dk_content', this.dk_content)
        formData.append('no_content', this.no_content)
        formData.append('cn_content', this.cn_content)
        formData.append('ro_content', this.ro_content)
        formData.append('es_content', this.es_content)
        formData.append('it_content', this.it_content)
        formData.append('hu_content', this.hu_content)
        formData.append('pl_content', this.pl_content)
        formData.append('cz_content', this.cz_content)
        formData.append('sk_content', this.sk_content)
        formData.append('pt_content', this.pt_content)
        formData.append('nl_content', this.nl_content)
        formData.append('bg_content', this.bg_content)
        formData.append('sv_content', this.sv_content)
        formData.append('gr_content', this.gr_content)
        formData.append('ru_content', this.ru_content)
        formData.append('et_content', this.et_content)

        this.$http.post(`${this.$api_url}/template/create`, formData).then((data, error) => {
          if (data && data.data.message === 'Template saved!') {
            this.reloadTable()
            this.errors = ''
            this.tname = ''
            this.description = ''
            this.gb_content = ''
            this.de_content = ''
            this.dk_content = ''
            this.no_content = ''
            this.cn_content = ''
            this.ro_content = ''
            this.es_content = ''
            this.it_content = ''
            this.hu_content = ''
            this.pl_content = ''
            this.cz_content = ''
            this.sk_content = ''
            this.pt_content = ''
            this.nl_content = ''
            this.bg_content = ''
            this.sv_content = ''
            this.gr_content = ''
            this.ru_content = ''
            this.et_content = ''
          } else {
            // alert('Duplicate Affiliate code!');
            this.errors = data.data.message
          }
        })
      }
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    deleteTemplate (id) {
      if (prompt('Are you sure? Type "delete" if yes!') === 'delete') {
        this.$http.delete(`${this.$api_url}/template/delete/${id}`).then((success) => {
          this.reloadTable()
        })
      } else {
        alert('Template not deleted!')
      }
    },
    editTemplate (data) {
      Bus.$emit('editTemplate', data)
      this.$bvModal.show('template-edit')
    },
    doFilter () {
      this.moreParams = {
        filter: this.filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetFilter () {
      this.filterText = ''
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    formatLangs (value) {
      let langs = ''
      value.forEach((val, iteration) => {
        langs += val + ', '
      })
      langs = langs.substring(0, langs.length - 2)
      return `<strong>${langs}</strong>`
    }
  },
  created () {
    this.api_url = `${this.$api_url}/templates`
    Bus.$on('templateUpdated', () => {
      this.reloadTable()
    })
  },
  beforeDestroy () {
    Bus.$off('templateUpdated')
  }
}
</script>
